const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

export function normalizeDateOnly(
  value: Date | string | null | undefined,
): string | null {
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) {
      return null;
    }

    const year = value.getFullYear();
    if (year < 0 || year > 9999) {
      return null;
    }

    return formatParts(year, value.getMonth() + 1, value.getDate());
  }

  if (typeof value !== 'string' || value.length === 0) {
    return null;
  }

  return parseDateOnly(value) ? value : null;
}

export function parseDateOnly(value: string | null | undefined): Date | null {
  if (typeof value !== 'string') {
    return null;
  }

  const match = DATE_ONLY_PATTERN.exec(value);
  if (!match) {
    return null;
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const parsed = new Date(0);
  parsed.setHours(0, 0, 0, 0);
  parsed.setFullYear(year, month - 1, day);

  if (
    parsed.getFullYear() !== year
    || parsed.getMonth() !== month - 1
    || parsed.getDate() !== day
  ) {
    return null;
  }

  return parsed;
}

export function todayDateOnly(now: Date = new Date()): string | null {
  return normalizeDateOnly(now);
}

function formatParts(year: number, month: number, day: number): string {
  return `${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}
